import React from "react";
import { Box, Typography, TextField, Paper } from "@material-ui/core";
import { listarValoresDistintos } from "./attributeLogic";

// Por cada atributo seleccionado, lista sus valores distintos y permite
// editar el texto que se muestra en la etiqueta para cada uno — prellenado
// con el texto natural (la descripción de modalidad, el nombre de la
// categoría, el texto de la opción del campo, etc.).
export default function ValueRemapEditor({
  selectedAttributes,
  atributosDisponibles,
  participantesFiltrados,
  eventSubEventsRegistry,
  valueRemap,
  onChange,
}) {
  const atributosPorKey = {};
  atributosDisponibles.forEach((a) => {
    atributosPorKey[a.key] = a;
  });

  function cambiarTexto(attributeKey, raw, texto) {
    const actual = valueRemap[attributeKey] || {};
    onChange({
      ...valueRemap,
      [attributeKey]: { ...actual, [String(raw)]: { display: texto } },
    });
  }

  if (!selectedAttributes || selectedAttributes.length === 0) {
    return (
      <Typography variant="body2" style={{ opacity: 0.7 }}>
        Selecciona al menos un atributo arriba para poder editar cómo se muestra cada valor.
      </Typography>
    );
  }

  return (
    <Box>
      {selectedAttributes.map((attributeKey) => {
        const meta = atributosPorKey[attributeKey];
        const valores = listarValoresDistintos(
          attributeKey,
          meta,
          participantesFiltrados,
          eventSubEventsRegistry
        );
        if (valores.length === 0) return null;
        return (
          <Box key={attributeKey} mb={3}>
            <Typography variant="subtitle2" gutterBottom>
              {meta ? meta.label : attributeKey}
            </Typography>
            <Paper variant="outlined" style={{ padding: 12 }}>
              {valores.map((v) => {
                const override = valueRemap[attributeKey] && valueRemap[attributeKey][String(v.raw)];
                const valorTexto =
                  override && override.display !== undefined ? override.display : v.label;
                return (
                  <Box key={v.raw} display="flex" alignItems="center" style={{ gap: 12 }} mb={1}>
                    <Typography variant="body2" style={{ minWidth: 220 }}>
                      {v.label}
                    </Typography>
                    <TextField
                      size="small"
                      label="Texto a mostrar"
                      value={valorTexto}
                      onChange={(e) => cambiarTexto(attributeKey, v.raw, e.target.value)}
                    />
                  </Box>
                );
              })}
            </Paper>
          </Box>
        );
      })}
    </Box>
  );
}
